export default __webpack_public_path__ + "static/media/eye.bafa23dd.png";